import { generateThumbnail } from '@halo/utils';
import { MsgPayloadType } from '@halo/chat-sdk';
import type { FileInfo, PictureInfo } from '../file';

export function getFileBaseInfo(file: File) {
  const fileInfo: FileInfo | PictureInfo = {
    name: file.name,
    size: file.size,
    type: file.type,
    ext: /\.([^.]+)$/.exec(file.name)?.[1] || '',
    meta: {},
  };

  return fileInfo;
}

export async function getPictureInfo(file: File) {
  const pictureInfo: PictureInfo = Object.assign(getFileBaseInfo(file), {
    width: 0,
    height: 0,
    thumbnail: '',
  });

  const result = await generateThumbnail(file);
  if (result) {
    const { getDataUrl, originalWidth, originalHeight } = result;
    pictureInfo.thumbnail = getDataUrl();
    pictureInfo.width = originalWidth;
    pictureInfo.height = originalHeight;
  }

  return pictureInfo;
}

export function isImageMessage(msg: any) {
  return msg.payload_type && MsgPayloadType.IMAGE == msg.payload_type;
}

export function isPNGImageMessage(msg: any) {
  return (
    msg.payload_type &&
    MsgPayloadType.IMAGE == msg.payload_type &&
    msg.payload.type === 'image/png'
  );
}

export function isFileMessage(msg: any) {
  return (
    msg.payload_type &&
    MsgPayloadType.IMAGE <= msg.payload_type &&
    msg.payload_type <= MsgPayloadType.FILE
  );
}
